module.exports = __webpack_public_path__ + "static/media/cp2h.14980f21.png";